exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headingDoctorMenuMedicalCourse[data-v-63686153]{color:#2a2e31}.headingDoctorMenuMedicalCourse[data-v-63686153]:before{content:\"\";position:relative;top:2px;display:inline-block;width:10px;height:20px;border-left:5px solid #536ea1;padding-right:5px}", ""]);

// exports
